/**
 * @generated SignedSource<<723e491a15ec21972dd962ca0e8f8ba8>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511

import type { ConcreteRequest } from 'relay-runtime';
export type preloadWebItemLocationWithSpaceKeyQuery$variables = {
  location?: string | null;
  locations?: ReadonlyArray<string | null> | null;
  spaceKey?: string | null;
  version?: number | null;
};
export type preloadWebItemLocationWithSpaceKeyQuery$data = {
  readonly space: {
    readonly homepageId: string | null;
    readonly homepageWebSections: ReadonlyArray<{
      readonly cacheKey: string | null;
      readonly id: string | null;
      readonly items: ReadonlyArray<{
        readonly accessKey: string | null;
        readonly completeKey: string | null;
        readonly hasCondition: boolean | null;
        readonly icon: {
          readonly height: number | null;
          readonly path: string;
          readonly width: number | null;
        } | null;
        readonly id: string | null;
        readonly label: string | null;
        readonly moduleKey: string | null;
        readonly params: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
        readonly section: string | null;
        readonly styleClass: string | null;
        readonly tooltip: string | null;
        readonly url: string | null;
        readonly urlWithoutContextPath: string | null;
        readonly weight: number | null;
      } | null>;
      readonly label: string | null;
      readonly styleClass: string | null;
    } | null> | null;
    readonly id: string | null;
  } | null;
};
export type preloadWebItemLocationWithSpaceKeyQuery = {
  response: preloadWebItemLocationWithSpaceKeyQuery$data;
  variables: preloadWebItemLocationWithSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "location"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locations"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "version"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "label"
},
v3 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "homepageId"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "location",
            "variableName": "location"
          },
          {
            "kind": "Variable",
            "name": "locations",
            "variableName": "locations"
          },
          {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
          }
        ],
        "concreteType": "WebSection",
        "kind": "LinkedField",
        "name": "homepageWebSections",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "cacheKey"
          },
          (v3/*: any*/),
          {
            "concreteType": "WebItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accessKey"
              },
              {
                "kind": "ScalarField",
                "name": "completeKey"
              },
              {
                "kind": "ScalarField",
                "name": "hasCondition"
              },
              (v1/*: any*/),
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "height"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "width"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              },
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "params",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              },
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "moduleKey"
              },
              {
                "kind": "ScalarField",
                "name": "section"
              },
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "tooltip"
              },
              {
                "kind": "ScalarField",
                "name": "url"
              },
              {
                "kind": "ScalarField",
                "name": "urlWithoutContextPath"
              },
              {
                "kind": "ScalarField",
                "name": "weight"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadWebItemLocationWithSpaceKeyQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadWebItemLocationWithSpaceKeyQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
    "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
    "metadata": {},
    "name": "preloadWebItemLocationWithSpaceKeyQuery",
    "operationKind": "query",
    "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
  }
};
})();

(node as any).hash = "fb9ef136f5257fc82dc16b8dc37de41b";

export default node;
